import { render } from "./NodeFact.vue?vue&type=template&id=4c907998&scoped=true"
import script from "./NodeFact.vue?vue&type=script&lang=js"
export * from "./NodeFact.vue?vue&type=script&lang=js"

import "./NodeFact.vue?vue&type=style&index=0&id=4c907998&scoped=true&lang=css"
/* custom blocks */
import block0 from "./NodeFact.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c907998"]])

export default __exports__